import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/LegalPage";

export const Route = createFileRoute("/privacidad")({
  head: () => ({ meta: [{ title: "Privacidad · SUSIEDAD" }] }),
  component: Privacy,
});
function Privacy() {
  return (
    <LegalPage eyebrow="Legal · Privacidad" title="POLÍTICA DE PRIVACIDAD">
      <section>
        <h2>Responsable y contacto</h2>
        <p>
          SUSIEDAD trata las solicitudes recibidas a través de esta web. Contacto:
          lasusiedad@gmail.com.
        </p>
      </section>
      <section>
        <h2>Finalidades</h2>
        <p>
          Los datos del formulario se utilizan exclusivamente para responder consultas, preparar
          propuestas, gestionar eventos contratados y facilitar el portal privado asociado.
        </p>
      </section>
      <section>
        <h2>Base y conservación</h2>
        <p>
          Las solicitudes se tratan con el consentimiento indicado en el formulario. Los datos de
          clientes se conservarán durante la relación profesional y los plazos legalmente exigibles;
          las solicitudes no convertidas se revisarán periódicamente para su eliminación.
        </p>
      </section>
      <section>
        <h2>Derechos</h2>
        <p>
          Puedes solicitar acceso, rectificación, eliminación, oposición, limitación o portabilidad
          escribiendo a lasusiedad@gmail.com. No se instalan cookies analíticas ni publicitarias en
          esta versión.
        </p>
      </section>
    </LegalPage>
  );
}
